import React from 'react'
import styled from 'styled-components'
import { Field } from 'redux-form'
import { Input } from 'components/common/FormElements/Input'
import model from '../../../viewModel'

const ServicesComment = () =>
  <Wrapper>
    <Field
      component={ Input }
      maxLength={ 200 }
      full
      { ...model.serviceComment } />
  </Wrapper>

export default ServicesComment

const Wrapper = styled.div`
  margin: 15px 0;

  & textarea {
    height: 90px;
  }

  @media (max-width: 750px) {
    height: 140px;
  }
`
